// extracted by mini-css-extract-plugin
export default {"videoContainer":"index_videoContainer_QqPHa","containerMargin":"index_containerMargin_YBQUS"};